module.exports = __webpack_public_path__ + "img/IMAGE 1.b0df9c1b.png";